import { createBrowserHistory } from "history"

// Create Custom Sentry Route components
export const history = createBrowserHistory()
